import { getStateSliceFor } from 'redux/Studio';

const initialState = {
  // ProductBrowser gets its products from ProductSearch service.
  //
  // We currently only display results from 1 search at any given
  // time (modulo request-in-flight time where we might display an
  // overlay over the old search results while waiting for the new ones).
  //
  // We have the concept of a "selected" product. Selecting
  // a product triggers transition to product alternatives
  // search type. No selected product implies we should be
  // using products in design search.
  //
  // So this state contains the current search name and type.
  searchKey: '',
  searchType: ''
};

export const productBrowserReducerKey = 'productBrowser';
export const productBrowserReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LS_PB/SET_ACTIVE_SEARCH': {
      const { searchKey, searchType } = action.payload;
      return { ...state, searchKey, searchType };
    }
    default:
      return state;
  }
};

// =========
// SELECTORS
// =========
const extractStateSlice = (state) => getStateSliceFor({ state, reducerKey: productBrowserReducerKey });
export const getSearchKey = (state) => extractStateSlice(state).searchKey;
export const getCurrentSearchKey = () => (dispatch, getState) => getSearchKey(getState());
export const getSearchType = (state) => extractStateSlice(state).searchType;
export const getCurrentSearchType = () => (dispatch, getState) => getSearchType(getState());

// =======
// ACTIONS
// =======
export const setSearchType = ({ searchKey, searchType }) => ({
  type: 'LS_PB/SET_ACTIVE_SEARCH',
  payload: { searchKey, searchType }
});
